import { useEffect, useState } from "react";
import temp1 from "../assets/biodata/templates/temp-1.svg";
import temp2 from "../assets/biodata/templates/temp-2.svg";
import temp3 from "../assets/biodata/templates/temp-3.svg";
import temp4 from "../assets/biodata/templates/temp-4.svg";
import temp5 from "../assets/biodata/templates/temp-5.svg";
import temp6 from "../assets/biodata/templates/temp-6.svg";
import temp7 from "../assets/biodata/templates/temp-7.svg";
import temp8 from "../assets/biodata/templates/temp-8.svg";
import temp9 from "../assets/biodata/templates/temp-9.svg";
import temp10 from "../assets/biodata/templates/temp-10.svg";
import temp11 from "../assets/biodata/templates/temp-11.svg";
import temp12 from "../assets/biodata/templates/temp-12.svg";

export default function TemplateSelector({ selected, onSelect }) {
  const [templates, setTemplates] = useState([]);

  useEffect(() => {
    const localTemplates = [
      { id: 11, img: temp11, imgpre: temp11 , sectionHeight : 65},
      { id: 12, img: temp12, imgpre: temp12 , sectionHeight : 80},
      { id: 1, img: temp1, imgpre: temp1 , sectionHeight : 55},
      { id: 2, img: temp2, imgpre: temp2 , sectionHeight : 35},
      { id: 3, img: temp3, imgpre: temp3 , sectionHeight : 35},
      { id: 4, img: temp4, imgpre: temp4 , sectionHeight : 85},
      { id: 5, img: temp5, imgpre: temp5 , sectionHeight : 55},
      { id: 6, img: temp6, imgpre: temp6 , sectionHeight : 55},
      { id: 7, img: temp7, imgpre: temp7 , sectionHeight : 75},
      { id: 8, img: temp8, imgpre: temp8 , sectionHeight : 55},
      { id: 9, img: temp9, imgpre: temp9 , sectionHeight : 55},
      { id: 10, img: temp10, imgpre: temp10 , sectionHeight : 55}
    ];

    setTemplates(localTemplates);

    if (!selected && !localStorage.getItem("biodata_template")) {
      onSelect(localTemplates[0]);
    }
  }, [selected, onSelect]);

  return (
    <div>
   
      <div className="bd_template_list">
        {templates.map((tpl) => (
          <div className="bd_template_block"
            key={tpl.id}
            onClick={() => onSelect(tpl)}
            style={{
             
              cursor: "pointer",
              border:
                selected?.id === tpl.id
                  ? "4px solid #333"
                  : "1px solid #ccc",
             
            }}
          >
            <img
              src={tpl.imgpre}
              alt={`Template ${tpl.id}`}
              draggable={false}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
